export const RenderingMode = {
    YASGUI: 'mode-yasgui',
    YASQE: 'mode-yasqe',
    YASR: 'mode-yasr'
};
